import { Box, Grid, GridItem, Text } from "@chakra-ui/react";
import TableView from "services/Crm/components/TabularView/TableView";
import InterviewDetailsCard from "services/Recruit/components/RecruitCards/TodaysInterviews";
import { RecruitCardData } from "services/Recruit/data/recruitData";

export default function RecruitHomePage() {
  return (
    <>
      <Grid templateColumns="repeat(4, 1fr)" gap={6}>
        {RecruitCardData.map((items) => (
          <Box
            className="recruit-info-card"
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Box className="recruit-info">
              <Box display={"flex"} alignItems={"center"} gap={"12px"}>
                <Text className="info-card-title">{items.title}</Text>
               
              </Box>

              <Text className="info-card-value">{items.value}</Text>
            </Box>
            <Box className="info-box-icon">
              <Box>
                {items.image}
              </Box>
            </Box>
          </Box>
        ))}
      </Grid>

      <Box className="recruit-info-box" marginTop={"40px"}>
        <Grid templateColumns="repeat(2, 1fr)" gap={6}>
          <GridItem colSpan={2} className="tableptNormal">
            <InterviewDetailsCard
              cardTitle={"Total Applications"}
              showTableCard={true}
            />
          </GridItem>
          <GridItem colSpan={1}>
            <InterviewDetailsCard
              cardTitle={"Today's Interview"}
              showCardDetails={true}
            />
          </GridItem>
          <GridItem colSpan={1}>
            <InterviewDetailsCard
              cardTitle={"Open Jobs"}
              showCardDetails={true}
            />
          </GridItem>
        </Grid>
      </Box>
    </>
  );
}
